<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_GENERIC_CAPTION_SHARE_DATA"
        :close="closeDialog"
        maxCardHeight="500"
        :alvqa="alvqa"
    >
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="dataSharingCode"
                            :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_ALV_DATA_SHARING_CODE')"
                            hide-details
                            :alvqa="alvqa + '-textfield-data-sharing-code'"
                        >
                            <template v-slot:append>
                                <BaseTooltip>
                                    <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                                    <template v-slot:text><span>{{ $t('lang_ACCOUNT_COMPANIES_CAPTION_ALV_DATA_SHARING_CODE_DESCRIPTION') }}</span></template>
                                </BaseTooltip>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                        <BaseButton 
                            @click="apply"
                            label="lang_GENERIC_CAPTION_APPLY"
                            :alvqa="alvqa+'-button-send'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "DataSharingDialog",
    props: {
        context: String,
        domain: String, // needed for api call, to know the context, e.g. 'publishing_works'
    },
    data() {
        return {
            valid: true,
            alvqa: 'data-sharing-dialog',
            dataSharingCode: "",
        }
    },
    components: {
        BaseDialog,
        BaseButton,
        BaseTooltip,
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowDataSharingDialog },
            set(show) { this.$store.commit('setShowDataSharingDialog', show) }
        },
        numberOfSearchItems() {
            return this.$store.getters.getTotalListed
        },
        searchTermUsed() {
            let searchGetters = {
                'publishing_works': 'getWorksSearch'
            }

            if (!searchGetters[this.domain]) {
                console.warn('No domain set...')
                return null;
            }

            return this.$store.getters[searchGetters[this.domain]]
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.dataSharingCode = ""
        },
        async apply() {
            await this.$store.dispatch('sendDataSharingRequest', {
                domain: this.domain, 
                dataSharingCode: this.dataSharingCode, 
                numberOfRecords: this.numberOfSearchItems,
                searchTerm: this.searchTermUsed
            })
            
            this.closeDialog()
        }
    }
}
</script>